import React, { useState } from 'react';
import { X } from '@phosphor-icons/react';

/**
 * Modal para capturar el motivo de solicitud de validación de una tarea
 * @param {boolean} isOpen - Si el modal está abierto
 * @param {Function} onClose - Callback para cerrar sin confirmar
 * @param {Function} onConfirm - Callback con el motivo: (reasonTechnician: string) => void
 * @param {boolean} isLoading - Si la petición está en curso
 */
function ValidationRequestModal({ isOpen, onClose, onConfirm, isLoading }) {
    const [reason, setReason] = useState('');
    const [error, setError] = useState('');

    const handleConfirm = () => {
        if (!reason.trim()) {
            setError('El motivo es requerido.');
            return;
        }
        setError('');
        onConfirm(reason.trim());
    };

    const handleClose = () => {
        setReason('');
        setError('');
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-[var(--app-overlay)] flex items-center justify-center z-[10000]">
            <div className="bg-surface rounded-xl shadow-xl w-[90vw] max-w-md border border-line flex flex-col">
                {/* Header */}
                <div className="flex justify-between items-center p-5 border-b border-line">
                    <h3 className="text-lg font-bold text-content">Solicitar Validación</h3>
                    <button
                        onClick={handleClose}
                        disabled={isLoading}
                        className="text-content-muted hover:text-content transition-colors p-1 disabled:opacity-50"
                    >
                        <X size={20} weight="bold" />
                    </button>
                </div>

                {/* Body */}
                <div className="p-5 space-y-4">
                    <div className="flex flex-col gap-2">
                        <label className="text-sm font-medium text-content-muted">
                            Motivo <span className="text-error">*</span>
                        </label>
                        <textarea
                            value={reason}
                            onChange={(e) => {
                                setReason(e.target.value);
                                if (error) setError('');
                            }}
                            disabled={isLoading}
                            rows={4}
                            placeholder="Describe el motivo por el cual solicitas esta validación..."
                            className="bg-surface-2 text-content border border-line focus:outline-none focus:ring-2 focus:ring-amber text-sm rounded-lg p-3 resize-none transition-colors disabled:opacity-50 placeholder-content-muted"
                        />
                        {error && (
                            <p className="text-error text-xs">{error}</p>
                        )}
                    </div>
                </div>

                {/* Footer */}
                <div className="p-4 border-t border-line flex justify-end gap-3">
                    <button
                        onClick={handleClose}
                        disabled={isLoading}
                        className="px-4 py-2 bg-surface-2 hover:bg-line text-content rounded-lg transition-colors disabled:opacity-50"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleConfirm}
                        disabled={isLoading || !reason.trim()}
                        className="px-4 py-2 bg-amber hover:bg-amber-hover text-on-amber rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-medium"
                    >
                        {isLoading ? 'Enviando...' : 'Validar'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ValidationRequestModal;
